import Mutations from '../../odata/mutations';

export default { ...new Mutations('contractFile'), ...new Mutations('contractFiles') };
